import { Box, IconButton, Stack, Typography, Button } from '@mui/material';
import AddWorkExperience from 'components/basic-profile/AddWorkExperience';
import { DeleteSvg, WhiteEditSvgIcon } from 'components/icon/icon';
import { allCapitalize } from 'utils/Utils';

const backIcon = `${process.env.REACT_APP_HOMEPAGE}assets/back-arrow-white.png`;

/**
 * AddWorkExperienceDrawer is a component that renders a drawer to add or edit a work experience.
 * It takes the following props:
 * - id: The id of the work experience to be edited.
 * - workHistoryData: The work experience data to be edited.
 * - onCancel: A function that is called when the component should cancel.
 * - onUploadSuccess: A function that is called when the component should upload a file.
 * - onWorkExperienceDataChange: A function that is called when the component should change the work experience data.
 * - currentCompany: The current company.
 * - roleData: The role data.
 * - checkingOverlapping: A boolean that indicates if the component should check overlapping.
 * - handleDeleteWork: A function that is called when the component should delete a work experience.
 * - selected: The selected work experience.
 * - handleArrowClick: A function that is called when the component should go back.
 * - workHistoryLength: The length of the work history.
 * - showWork: A boolean that indicates if the component should show the work experience.
 * - handleShowWork: A function that is called when the component should show the work experience.
 * - handleDeleteEdu: A function that is called when the component should delete an education.
 * - isReadOnly: A boolean that indicates if the component is read only.
 * - setReadOnly: A function that is called when the component should set read only.
 */

const AddWorkExperienceDrawer = ({
    id,
    workHistoryData,
    onCancel,
    onUploadSuccess,
    onWorkExperienceDataChange,
    currentCompany,
    roleData,
    checkingOverlapping,
    handleDeleteWork,
    selected,
    handleArrowClick,
    workHistoryLength,
    showWork, handleShowWork, handleDeleteEdu, isReadOnly, setReadOnly,deleteIncompleteSection
}) => {
    return (
        <Box className="sidebar-wrapper">
            <Box className="sidebar-header">
                <Stack direction="row" justifyContent={'flex-start'} alignItems={'flex-start'} spacing={2}>
                    <IconButton aria-label="delete" onClick={() => handleArrowClick()}>
                        <img src={backIcon} alt="Back" width="20px" height="20px" loading="lazy" />
                    </IconButton>
                    <Stack direction="row" justifyContent={'space-between'} alignItems={'flex-start'} sx={{ minWidth: '100%' }}>
                        <Stack spacing={0.5}>
                            <Typography className="title">Add Work Experience</Typography>
                            <Typography className="sub-text" sx={{ width: '85%' }}>
                                {workHistoryData && workHistoryData?.highest_designation && workHistoryData?.organization_name ? `${workHistoryData?.highest_designation} at ${allCapitalize(workHistoryData?.organization_name)}`
                                    : 'Select Designation & Company'}
                            </Typography>
                        </Stack>
                        {!isReadOnly ?
                            <IconButton className="delete-sec-btn" aria-label="delete" onClick={id ? (e) => { handleDeleteWork(selected?._id, selected?.organization_name, e) } : deleteIncompleteSection}>
                                <DeleteSvg />
                            </IconButton> :
                            <IconButton aria-label="delete" className="edit-icon" disableRipple onClick={() => setReadOnly(false)} sx={{ position: 'absolute', right: '20px', top: '6px' }}>
                                <WhiteEditSvgIcon />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            </Box>
            <Box className="sidebar-content" sx={{ backgroundColor: showWork && '#FAFAFA!important' }}>
                <AddWorkExperience
                    id={id}
                    workHistoryData={workHistoryData}
                    onCancel={onCancel}
                    onUploadSuccess={onUploadSuccess}
                    onWorkExperienceDataChange={onWorkExperienceDataChange}
                    currentCompany={currentCompany}
                    roleData={roleData}
                    checkingOverlapping={checkingOverlapping}
                    handleArrowClick={handleArrowClick}
                    workHistoryLength={workHistoryLength}
                    showWork={showWork}
                    handleShowWork={handleShowWork}
                    handleDeleteEdu={handleDeleteEdu}
                    isReadOnly={isReadOnly}
                    setReadOnly={setReadOnly}
                />
            </Box>
        </Box>
    )
}

export default AddWorkExperienceDrawer
